/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PreviewConfigurationRequest
 */
export interface PreviewConfigurationRequest {
    /**
     * The scope's complete override to preview, validated against the key's schema
     */
    value: any | null;
}

/**
 * Check if a given object implements the PreviewConfigurationRequest interface.
 */
export function instanceOfPreviewConfigurationRequest(value: object): value is PreviewConfigurationRequest {
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function PreviewConfigurationRequestFromJSON(json: any): PreviewConfigurationRequest {
    return PreviewConfigurationRequestFromJSONTyped(json, false);
}

export function PreviewConfigurationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreviewConfigurationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
    };
}

export function PreviewConfigurationRequestToJSON(json: any): PreviewConfigurationRequest {
    return PreviewConfigurationRequestToJSONTyped(json, false);
}

export function PreviewConfigurationRequestToJSONTyped(value?: PreviewConfigurationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'value': value['value'],
    };
}

